import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import {RichText} from "@wordpress/block-editor";
import PMGColorPalette,{fontColorAssociations} from "./PMGColorPalette";

import {PanelBody,Panel,RangeControl,SelectControl,CheckboxControl,TextControl,Button} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck,
    __experimentalLinkControl as LinkControl
} from '@wordpress/block-editor';

registerBlockType({
  "name":"template-scripts/button",
  "title":"Button",
  "category":"template-scripts",
  "icon":"button",
  attributes:{
    buttonText:{type:'string'},
    link:{type:'object'},
    size:{type:'string',default:'normal'},
    align:{type:'string',default:'left'},
    arrowIcon:{type:'boolean',default:false},
    backgroundColor:{type:'string',default:'#b65943'},
    fontColor:{type:'string',default:'#fff'}
  }
},{
  edit:function({attributes,setAttributes}){

    return (<>
    <InspectorControls>
      <Panel>
        <Panel>
          <PanelBody title="Button Link">
            <LinkControl placeholder="Button Link" onChange={(v)=>{ console.log(v); setAttributes({link:v}); }} value={attributes.link}/>
          </PanelBody>
        </Panel>
        <PanelBody title="Button Color">
          <PMGColorPalette
            value={attributes.backgroundColor}
            onChange={(v)=>{
              var fontColor = fontColorAssociations[v] || "#ffffff";
              setAttributes({
                fontColor,
                backgroundColor:v
              });
            }}
          />
        </PanelBody>
        <PanelBody title="Button Size">
          <SelectControl
            value={attributes.size}
            options={[
              {label:"Default",value:"default"},
              {label:"Large",value:"large"}
            ]}
            onChange={(v)=>setAttributes({size:v})}
          />
        </PanelBody>
        <PanelBody title="Button Icon">
            <CheckboxControl
              label="Show Forward Arrow Icon"
              checked={attributes.arrowIcon}
              onChange={(v)=>setAttributes({arrowIcon:v})}
            />
        </PanelBody>
      </Panel>

    </InspectorControls>
      <BlockControls>
        <AlignmentToolbar value={attributes.align} onChange={(a)=>setAttributes({align:a})}/>
      </BlockControls>
      
      <div className="textContain">
        <div className={`btn ${attributes.align} ${attributes.size}`} style={{fontSize:"1rem",lineHeight:"1.2rem",color:attributes.fontColor,backgroundColor:attributes.backgroundColor,background:attributes.backgroundColor}}>
          <RichText tagName="div" placeholder="Button Text" value={attributes.buttonText} onChange={(v)=>setAttributes({buttonText:v})}/>
          {attributes.arrowIcon ? (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M268 112l144 144-144 144M392 256H100"/></svg>
          ) : (<></>)}
        </div>
      </div>
    </>);
  },
  save:function({attributes}){
    if(attributes.buttonText == ""){
      return (<></>);
    }
    return (<div className="textContain">
      <a href={attributes.link?.url} className={`btn ${attributes.align} ${attributes.size}`} style={{color:attributes.fontColor,backgroundColor:attributes.backgroundColor,background:attributes.backgroundColor}}>
        <RichText.Content tagName="div" value={attributes.buttonText}/>
        {attributes.arrowIcon ? (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M268 112l144 144-144 144M392 256H100"/></svg>
        ) : (<></>)}
      </a>
      </div>);
  }
});
